import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { extractErrorMessage } from '../../api/client';

export default function ErrorBanner({ error, title = 'Something went wrong', onRetry }) {
  if (!error) return null;
  const msg = typeof error === 'string' ? error : extractErrorMessage(error);
  return (
    <div className="flex items-start gap-3 rounded-md border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-ink">
      <FiAlertCircle className="mt-0.5 text-danger" />
      <div className="flex-1">
        <div className="font-medium text-danger">{title}</div>
        <div className="whitespace-pre-line text-ink-muted">{msg}</div>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded border border-danger/40 px-2 py-1 text-xs text-danger hover:bg-danger/10"
        >
          Retry
        </button>
      )}
    </div>
  );
}
